import { gql } from '@apollo/client';

export const GET_COMPANY_SETTINGS = gql`
  query GetCompanyWithSettings {
    getCompanySettings {
      id
      companyName
      shopifyStores {
        currencyCode
      }
      settings {
        defaultSafetyStockWeeks
        fallbackSupplierDeliveryTime
        warningThreshold
        preferredMetric
        onhandSyncMode
        onhandSyncIntervalHours
        onhandSyncLastRequestedAt
      }
    }
  }
`;
